// Правила сообщества и политика данных.
//
// Pagina exista deja ca link în bara laterală, dar nu ducea nicăieri. Acum e cerută și
// de bifa de la înregistrare, iar o bifă care trimite într-un gol e mai rea decât lipsa
// ei: omul acceptă ceva ce nu poate citi.
//
// Textul spune ce facem cu datele exact cum e în cod — parole cu scrypt, chei de burse
// cifrate și doar pentru citire, adresa vizibilă numai proprietarului. Dacă vreodată
// codul se schimbă, se schimbă și textul de aici; altfel devine o minciună politicoasă.

import { el } from '../core/util.js';
import { icon } from '../ui/icons.js';

const SECTIUNI = [
  {
    ico: 'comments',
    titlu: 'Как вести себя в сообществе',
    puncte: [
      ['Уважение к участникам', 'Спорить о рынке — нормально. Переходить на личности, оскорблять или травить — нет.'],
      ['Никакой рекламы и продажи сигналов', 'Платные каналы, «наставничество», реферальные ссылки на сторонние сервисы — за это бан без предупреждения.'],
      ['Чужие идеи — с указанием автора', 'Публиковать чужой разбор под своим именем нельзя.'],
      ['Идея — это вход, цель и стоп', 'Без них это мнение, а не идея. Мнения пишите в чат, идеи — в раздел идей.'],
      ['Без скама и личных «инвест-предложений»', 'Просьбы перевести деньги, ссылки на подозрительные площадки, обещания доходности — удаляются, аккаунт блокируется.'],
    ],
  },
  {
    ico: 'lock',
    titlu: 'Что мы делаем с вашими данными',
    puncte: [
      ['Ник виден всем, почта — нет', 'Почтовый адрес видит только владелец сообщества, и только для поддержки и восстановления доступа.'],
      ['Почта нужна для двух вещей', 'Подтвердить, что адрес ваш, и восстановить пароль, если вы его забыли. Рассылок нет.'],
      ['Пароль не хранится', 'В базе лежит только scrypt-хэш. Мы не можем прочитать ваш пароль — и не сможем прислать его вам, только дать ссылку на смену.'],
      ['Ключи бирж — только на чтение', 'Если вы добавите API-ключ, он шифруется, а сервер проверяет, что ключ не умеет торговать. Ключ с правом на сделки не будет принят.'],
      ['Никому не передаём', 'Данные лежат на сервере проекта. Мы их не продаём, не передаём третьим лицам и не подключаем сторонние трекеры.'],
      ['Удаление аккаунта', 'Напишите владельцу — аккаунт и связанные с ним записи удаляются. Опубликованные сообщения можно удалить отдельно.'],
    ],
  },
  {
    ico: 'shieldCheck',
    titlu: 'Модерация',
    puncte: [
      ['Три ступени', 'Предупреждение → ограничение на запись → блокировка. За скам и рекламу — сразу блокировка.'],
      ['Кто решает', 'Владелец и модераторы. Решение можно оспорить — напишите в поддержку, разберём.'],
    ],
  },
  {
    ico: 'warning',
    titlu: 'Ответственность',
    puncte: [
      ['Это не инвестиционная рекомендация', 'Ни скринер, ни идеи участников, ни рейтинги не являются советом покупать или продавать. Решение всегда ваше.'],
      ['Данные могут быть неточными', 'Цифры приходят с бирж и могут запаздывать или прерываться. Перед сделкой проверяйте цену в терминале.'],
      ['Риск', 'Торговля с плечом может привести к потере всего депозита. Не торгуйте на деньги, которые вам нужны.'],
    ],
  },
];

export class RulesSection {
  constructor(app) {
    this.app = app;
  }

  mount(host) {
    this.root = el('div', { class: 'rules-section' }, [
      el('div', { class: 'rules-doc' }, [
        el('div', { class: 'ideas-head' }, [
          el('h2', { class: 'ideas-title', text: 'Правила сообщества и политика данных' }),
        ]),
        el('p', { class: 'rules-intro' }, [
          el('span', {
            text: 'Коротко: будьте людьми, не продавайте сигналы, а мы не торгуем вашими данными. '
              + 'Ниже — то же самое, но подробно.',
          }),
        ]),

        ...SECTIUNI.map((s) => el('section', { class: 'rules-block' }, [
          el('h3', { class: 'rules-h' }, [
            el('span', { class: 'rules-ico' }, [icon(s.ico, 14)]),
            el('span', { text: s.titlu }),
          ]),
          el('div', { class: 'rules-list' }, s.puncte.map(([t, x]) => el('div', { class: 'rules-item' }, [
            el('span', { class: 'rules-item-t', text: t }),
            el('span', { class: 'rules-item-x', text: x }),
          ]))),
        ])),

        el('p', { class: 'rules-foot' }, [
          el('span', { text: 'Правила могут меняться — существенные изменения объявляем в разделе «Обновления». ' }),
          el('span', { text: 'Вопросы и жалобы — через «Поддержку».' }),
        ]),
      ]),
    ]);
    host.append(this.root);
  }

  unmount() {
    this.root?.remove();
  }
}
